// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.1
// source: asr_settings.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "asr_settings";

/** Main proto definition */
export interface ASRSettings {
  bargeIn: boolean;
  latencyConfig: LatencyConfig | undefined;
  updatedBy?: string | undefined;
  updatedAt?: Date | undefined;
}

export interface LatencyConfig {
  interactionStyle: string;
}

/** commands */
export interface ASRSettingsUpdateASRSettings {
  bargeIn?: boolean | undefined;
  latencyConfig?: LatencyConfig | undefined;
}

function createBaseASRSettings(): ASRSettings {
  return { bargeIn: false, latencyConfig: undefined, updatedBy: undefined, updatedAt: undefined };
}

export const ASRSettings: MessageFns<ASRSettings> = {
  encode(message: ASRSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bargeIn !== false) {
      writer.uint32(8).bool(message.bargeIn);
    }
    if (message.latencyConfig !== undefined) {
      LatencyConfig.encode(message.latencyConfig, writer.uint32(18).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(26).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ASRSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseASRSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.bargeIn = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latencyConfig = LatencyConfig.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ASRSettings {
    return {
      bargeIn: isSet(object.bargeIn)
        ? globalThis.Boolean(object.bargeIn)
        : isSet(object.barge_in)
        ? globalThis.Boolean(object.barge_in)
        : false,
      latencyConfig: isSet(object.latencyConfig)
        ? LatencyConfig.fromJSON(object.latencyConfig)
        : isSet(object.latency_config)
        ? LatencyConfig.fromJSON(object.latency_config)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: ASRSettings): unknown {
    const obj: any = {};
    if (message.bargeIn !== false) {
      obj.bargeIn = message.bargeIn;
    }
    if (message.latencyConfig !== undefined) {
      obj.latencyConfig = LatencyConfig.toJSON(message.latencyConfig);
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ASRSettings>): ASRSettings {
    return ASRSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ASRSettings>): ASRSettings {
    const message = createBaseASRSettings();
    message.bargeIn = object.bargeIn ?? false;
    message.latencyConfig = (object.latencyConfig !== undefined && object.latencyConfig !== null)
      ? LatencyConfig.fromPartial(object.latencyConfig)
      : undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseLatencyConfig(): LatencyConfig {
  return { interactionStyle: "" };
}

export const LatencyConfig: MessageFns<LatencyConfig> = {
  encode(message: LatencyConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.interactionStyle !== "") {
      writer.uint32(10).string(message.interactionStyle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LatencyConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLatencyConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.interactionStyle = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LatencyConfig {
    return {
      interactionStyle: isSet(object.interactionStyle)
        ? globalThis.String(object.interactionStyle)
        : isSet(object.interaction_style)
        ? globalThis.String(object.interaction_style)
        : "",
    };
  },

  toJSON(message: LatencyConfig): unknown {
    const obj: any = {};
    if (message.interactionStyle !== "") {
      obj.interactionStyle = message.interactionStyle;
    }
    return obj;
  },

  create(base?: DeepPartial<LatencyConfig>): LatencyConfig {
    return LatencyConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LatencyConfig>): LatencyConfig {
    const message = createBaseLatencyConfig();
    message.interactionStyle = object.interactionStyle ?? "";
    return message;
  },
};

function createBaseASRSettingsUpdateASRSettings(): ASRSettingsUpdateASRSettings {
  return { bargeIn: undefined, latencyConfig: undefined };
}

export const ASRSettingsUpdateASRSettings: MessageFns<ASRSettingsUpdateASRSettings> = {
  encode(message: ASRSettingsUpdateASRSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bargeIn !== undefined) {
      writer.uint32(8).bool(message.bargeIn);
    }
    if (message.latencyConfig !== undefined) {
      LatencyConfig.encode(message.latencyConfig, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ASRSettingsUpdateASRSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseASRSettingsUpdateASRSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.bargeIn = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latencyConfig = LatencyConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ASRSettingsUpdateASRSettings {
    return {
      bargeIn: isSet(object.bargeIn)
        ? globalThis.Boolean(object.bargeIn)
        : isSet(object.barge_in)
        ? globalThis.Boolean(object.barge_in)
        : undefined,
      latencyConfig: isSet(object.latencyConfig)
        ? LatencyConfig.fromJSON(object.latencyConfig)
        : isSet(object.latency_config)
        ? LatencyConfig.fromJSON(object.latency_config)
        : undefined,
    };
  },

  toJSON(message: ASRSettingsUpdateASRSettings): unknown {
    const obj: any = {};
    if (message.bargeIn !== undefined) {
      obj.bargeIn = message.bargeIn;
    }
    if (message.latencyConfig !== undefined) {
      obj.latencyConfig = LatencyConfig.toJSON(message.latencyConfig);
    }
    return obj;
  },

  create(base?: DeepPartial<ASRSettingsUpdateASRSettings>): ASRSettingsUpdateASRSettings {
    return ASRSettingsUpdateASRSettings.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ASRSettingsUpdateASRSettings>): ASRSettingsUpdateASRSettings {
    const message = createBaseASRSettingsUpdateASRSettings();
    message.bargeIn = object.bargeIn ?? undefined;
    message.latencyConfig = (object.latencyConfig !== undefined && object.latencyConfig !== null)
      ? LatencyConfig.fromPartial(object.latencyConfig)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
